"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var EmptyState = function (props) {
    var title = props.title, _a = props.description, description = _a === void 0 ? '暂无数据' : _a, style = props.style, children = props.children;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(props.className, 'anq-empty-state-wrap'), style: style },
        react_1.default.createElement("img", { src: "https://commimg.pddpic.com/upload/mms/0befb9a9-7d06-495e-af51-b6234b7a7f68.png", style: { marginBottom: 12, width: 56, height: 56 } }),
        title ? react_1.default.createElement("div", { className: "anq-empty-state-title" }, title) : null,
        description ? react_1.default.createElement("div", { className: "anq-empty-state-description" }, description) : null,
        children ? react_1.default.createElement("div", { className: "anq-empty-state-content" }, children) : null));
};
exports.default = EmptyState;
//# sourceMappingURL=index.js.map